/* src/app/components/ai-assist/bottemplate/bottemplate.component.scss */
#right-side-panel {
  width: 20%;
  background: #fff;
  box-shadow: 0px 0px 4px #b2b2b2;
  padding: 10px;
}
/*# sourceMappingURL=bottemplate.component.css.map */
